export const PRECISION_CONVERSION = {
  ENERGY: 1000
};